import React from 'react';
import { COHeadlineProps } from '@components/framework/headlines/types.ts';
import { isNotNullOrUndefined } from '@utils/utils.tsx';
import clsx from 'clsx';

const COHeadline: React.FC<COHeadlineProps> = ({ variant, title, icon, iconColor, className, loading = false, actions }) => {
  const resolvedIconColor = iconColor ?? 'var(--ringil3-primary-color)';

  const renderIcon = () =>
    isNotNullOrUndefined(icon) && <div className={loading ? 'animate-spin' : ''}>{React.cloneElement(icon, { color: resolvedIconColor })}</div>;

  let heading: JSX.Element;
  switch (variant) {
    case 'h1':
      heading = (
        <h1 className={clsx('text-[1.625rem] font-normal text-zinc-600 flex flex-row gap-4 items-center leading-8', className)}>
          {renderIcon()}
          {title}
        </h1>
      );
      break;
    case 'h2':
      heading = (
        <h2 className={clsx('text-black text-xl font-normal flex flex-row gap-4 items-center', className)}>
          {renderIcon()}
          {title}
        </h2>
      );
      break;
    case 'h3':
      heading = (
        <h3 className={clsx('text-black text-lg font-normal flex flex-row gap-2 items-center', className)}>
          {renderIcon()}
          {title}
        </h3>
      );
      break;
    case 'h4':
      heading = (
        <h4 className={clsx('text-content-primary text-base font-medium  flex flex-row gap-2 items-center', className)}>
          {renderIcon()}
          {title}
        </h4>
      );
      break;
    case 'h5':
      heading = (
        <h5 className={clsx('text-black text-xs font-normal flex flex-row gap-2 items-center', className)}>
          {renderIcon()}
          {title}
        </h5>
      );
      break;
  }

  if (isNotNullOrUndefined(actions)) {
    return (
      <div className={'flex flex-row items-center justify-between gap-4 w-full'}>
        {heading}
        <div className={'flex flex-row items-center gap-2'}>{actions}</div>
      </div>
    );
  }

  return heading;
};

export default COHeadline;